/**
 * Display helpers for gallery storage. Binary units labelled MB/GB:
 * 100 MB = 104,857,600 bytes. UI-only; payloads always carry integer bytes.
 */

export const BYTES_PER_MB = 1024 * 1024
export const MAX_QUOTA_MB = 1_048_576 // 1 TiB

function trimmed(value: number): string {
  return value.toFixed(1).replace(/\.0$/, '')
}

export function formatBytes(bytes: number): string {
  if (bytes >= 1024 * BYTES_PER_MB) return `${trimmed(bytes / (1024 * BYTES_PER_MB))} GB`
  if (bytes >= BYTES_PER_MB) return `${trimmed(bytes / BYTES_PER_MB)} MB`
  if (bytes >= 1024) return `${trimmed(bytes / 1024)} KB`
  return `${bytes} B`
}

export function bytesToMb(bytes: number): number {
  return Math.round((bytes / BYTES_PER_MB) * 100) / 100
}

export function mbToBytes(mb: number): number {
  return mb * BYTES_PER_MB
}

export function isValidQuotaMb(mb: unknown): mb is number {
  return typeof mb === 'number' && Number.isInteger(mb) && mb >= 0 && mb <= MAX_QUOTA_MB
}

export function usagePercent(used: number, quota: number): number {
  if (quota <= 0) return used > 0 ? 100 : 0
  return Math.min(100, Math.round((used / quota) * 100))
}
